// extracted by mini-css-extract-plugin
export default {"anchor":"Steps_anchor__NMIcI","descriptionTextArea":"Steps_descriptionTextArea__ChXAe","socialIconsWrapper":"Steps_socialIconsWrapper__iVpTo"};